<template>
  <v-container fluid>
    <v-row>
      <v-col col="12" xl="12" md="12" xs="12">
        <!-- 회비 테이블 -->
        <loading-spinner v-if="isLoading"></loading-spinner>
        <simple-table v-else :title="$t('title.fee_type_management')" :columns="columns" :data="feeTypes">

          <!-- 버튼 영역 -->
          <template slot="buttons">
            <div class="d-flex justify-end mt-10 mr-3 mb-5">
              <custom-button @click="showForm" :label="$t('button.add')" color="primary" size="lg" gradient
                rounded></custom-button>
            </div>
          </template>
        </simple-table>

        <add-text-form v-if="showAddFeeTypeForm" :title="$t('title.add')" :buttons="textFormbuttons"
          :fields="textFormFields" @close="close" @save-data="saveFeeType" v-model="feeType"></add-text-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SimpleTable from '@/components/Tables/SimpleTable.vue';
import AddTextForm from '@/components/Forms/AddTextForm.vue';

import { getFeeTypeColumns } from '@/views/AccountView/columns';
import { feeTextFormFields } from '@/views/AccountView/fields';
import { deletePopup, success } from '@/views/AccountView/popups';

import { accountApi } from '@/api/api';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';

export default {
  components: {
    SimpleTable,
    AddTextForm,
    CustomButton,
    LoadingSpinner,
  },
  data() {
    return {

      // fields & columns 
      columns: getFeeTypeColumns({
        "delete": this.handleDelete,
      }),
      textFormFields: feeTextFormFields,
      textFormbuttons: [
        {
          label: this.$t("button.register"),
          class: "md-primary md-round",
          type: "submit",
          disabled: true,
          action: this.addFeeType,
        },
      ],

      // boolean
      isLoading: false,
      showAddFeeTypeForm: false,

      //  init data
      feeTypes: [],
      feeType: {
        idx: null,
        name: null,
        fee_krw: null,
        fee_usd: null,
        memo: null,
      },
    };
  },
  methods: {
    /**
     * FeeType 타입 명세
     * 
     * @typedef {Object} FeeType - 회비 유형
     * @property {number} idx - 회비 유형 idx
     * @property {string} name - 회비 유형명
     * @property {string} fee_krw - 회비 유형 금액 (KRW)
     * @property {string} fee_usd - 회비 유형 금액 (USD)
     * @property {string} memo - 메모 (Optional)
     */

    /**
     * 회비 유형 생성 요청 API
     * 
     * @description: 회비 유형 생성 요청 후 새롭게 회비 목록 조회
     * @param {FeeType} feeType 
     */
    saveFeeType(feeType) {
      this.isLoading = true;

      accountApi.createFeeType(feeType).then(() => {
        this.initFeeType();
        this.getFeeTypes();
        this.showForm();
      }).finally(() => this.isLoading = false);
    },

    async handleDelete(feeType) {
      const isConfirmed = await deletePopup(feeType);

      if (isConfirmed) {
        const isDeleted = await this.deleteFeeType(feeType);

        if (isDeleted) {
          await success();
        }
      }
    },

    /**
     * 회비 유형 제거 API 메서드
     * @param {FeeType} feeType 
     */
    async deleteFeeType(feeType) {
      try {
        this.isLoading = true;
        const response = await accountApi.deleteFeeType(feeType);

        if (response && response.status === 204) {
          await this.getFeeTypes();
          return true;
        } else {
          return false;
        }
      } catch (error) {
        // 알럿 추가
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    /** 
     * 회비 유형 목록 조회 API 메서드 
     */
    async getFeeTypes() {
      this.isLoading = true;

      accountApi.getFeeTypes().then(res => {
        this.feeTypes = res ? res.data.response : this.feeTypes;
      }).finally(() => this.isLoading = false);
    },

    /**
     * 회비 유형 등록 폼 렌더링 상태 관리 메서드
     */
    showForm() {
      this.showAddFeeTypeForm = !this.showAddFeeTypeForm;
    },

    /**
     * 폼 모달 닫는 메서드
     */
    close() {
      this.showForm();
      this.initFeeType();
    },

    /**
     * 폼 내의 feeType 정보 초기화
     */
    initFeeType() {
      this.feeType = {
        idx: null,
        name: null,
        fee_krw: null,
        fee_usd: null,
        memo: null,
      };
    },
  },
  mounted() {
    this.getFeeTypes();
  },
};
</script>

<style lang="scss" scoped>
.md-button-group {
  display: flex;
  justify-content: flex-end;
  margin: 10px;
}
</style>